import React, { useContext, useMemo } from "react";
import { RouteProps } from "react-router";
import { Redirect, Route } from "react-router-dom";
import { AuthContext } from "../../../contexts/auth";
import { Loading } from "../../ui/Loading";

interface RWebsiteProtectedRouteProps extends RouteProps {
  redirect?: string | React.FC;
}

const WebsiteProtectedRoute: React.FC<RWebsiteProtectedRouteProps> = (
  props
) => {
  const { isLoggedIn } = useContext(AuthContext);
  const isAuthorized = useMemo(() => isLoggedIn, [isLoggedIn]);

  return isAuthorized === null ? (
    <div className="flex flex-col items-center mt-48">
      <Loading className="w-12" />
      <span className="mt-4 text-lg font-medium">Please Wait</span>
      <span className="mt-2 text-sm font-medium text-subtitle">
        Fetching information
      </span>
    </div>
  ) : isAuthorized ? (
    <Route {...props} />
  ) : props.redirect === undefined || typeof props.redirect === "string" ? (
    <Redirect to={{ pathname: props.redirect || "/" }} />
  ) : (
    <Route {...props} component={props.redirect} />
  );
};

export default WebsiteProtectedRoute;
